import API from "../const/api";
import httpService, { IResponse } from "./HttpService";

export class CouponService {
  static validateCoupon(couponCode: string): Promise<IResponse> {
    const url = `${API.couponValid.replace(":couponCode", couponCode)}`;
    return httpService.get(url);
  }
}
